{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "https://ceo-os.local/schemas/v1/data-import-report.schema.json",
  "title": "DataImportReport v1",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "schema_name",
    "schema_version",
    "contract_id",
    "produced_at",
    "producer",
    "payload_hash",
    "payload"
  ],
  "properties": {
    "schema_name": { "const": "data-import-report" },
    "schema_version": { "const": "1.0.0" },
    "contract_id": { "type": "string", "format": "uuid" },
    "produced_at": { "type": "string", "format": "date-time" },
    "producer": { "const": "ceo-os" },
    "payload_hash": { "type": "string", "pattern": "^[a-f0-9]{64}$" },
    "payload": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "import_id",
        "imported_at",
        "source_file_name",
        "source_schema_name",
        "source_schema_version",
        "status",
        "added",
        "skipped",
        "conflicts",
        "errors"
      ],
      "properties": {
        "import_id": { "type": "string", "format": "uuid" },
        "imported_at": { "type": "string", "format": "date-time" },
        "source_file_name": { "type": "string", "minLength": 1 },
        "source_schema_name": { "type": "string", "minLength": 1 },
        "source_schema_version": { "type": "string", "minLength": 1 },
        "status": { "enum": ["valid", "rejected", "needs_confirmation", "committed"] },
        "added": { "type": "integer", "minimum": 0 },
        "skipped": { "type": "integer", "minimum": 0 },
        "conflicts": {
          "type": "array",
          "items": {
            "type": "object",
            "additionalProperties": false,
            "required": ["entity_type", "incoming_id", "reason"],
            "properties": {
              "entity_type": { "type": "string", "minLength": 1 },
              "incoming_id": { "type": "string", "minLength": 1 },
              "local_id": { "type": ["string", "null"] },
              "reason": {
                "enum": [
                  "duplicate",
                  "local_newer",
                  "same_date_different_payload",
                  "unsupported_version"
                ]
              }
            }
          }
        },
        "errors": {
          "type": "array",
          "items": {
            "type": "object",
            "additionalProperties": false,
            "required": ["code", "path", "message"],
            "properties": {
              "code": { "type": "string", "minLength": 1 },
              "path": { "type": "string" },
              "message": { "type": "string", "minLength": 1 }
            }
          }
        }
      }
    }
  },
  "examples": [
    {
      "schema_name": "data-import-report",
      "schema_version": "1.0.0",
      "contract_id": "9559c008-1682-430f-a466-4e2081c81726",
      "produced_at": "2026-07-26T22:10:00+08:00",
      "producer": "ceo-os",
      "payload_hash": "6628cb1cb8213f94d1b5112fc32133acc39380274a02c20b15ab71587fbad195",
      "payload": {
        "import_id": "18bcd17d-4f17-46e7-af6c-965269566f49",
        "imported_at": "2026-07-26T22:10:00+08:00",
        "source_file_name": "ceo-os-backup.json",
        "source_schema_name": "data-export-package",
        "source_schema_version": "1.0.0",
        "status": "valid",
        "added": 0,
        "skipped": 0,
        "conflicts": [],
        "errors": []
      }
    }
  ]
}
